<template>
  <div class="tw:bg-blue-200 tw:py-4 tw:px-5 tw:rounded-xl tw:flex tw:gap-[2px] tw:items-start tw:flex-col">
    <p class="tw:font-bold tw:text-sm">
      {{ $t('plus_peformance_empty_state_info') }}
    </p>
    <p class="tw:text-sm">{{ $t('plus_performance_empty_state_subtext') }}</p>
  </div>
</template>
